import { MenuItem } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { SELECT_MENU_ITEM_ROUTES } from 'features/header/constants/header-select-menu-item.const';
import useAuth from 'features/auth/hooks/use-auth';
import { HeaderSelectMenuItemsEnum } from 'features/header/enums/header-select-menu-items.enum';
import { ROUTES } from 'routes/constants';

type Props = {
  selectMenuItem: string;
};

const HeaderSelectMenuItem: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const handleClick = () => {
    if (props.selectMenuItem === HeaderSelectMenuItemsEnum.LOGOUT) {
      signOut();
      navigate(ROUTES.dynamic.signIn(undefined));
    } else {
      const route = SELECT_MENU_ITEM_ROUTES[props.selectMenuItem];
      if (route) {
        navigate(route);
      } else {
        console.warn(`No route configured for: ${props.selectMenuItem}`);
      }
    }
  };

  return (
    <MenuItem value={props.selectMenuItem} onClick={handleClick}>
      {props.selectMenuItem}
    </MenuItem>
  );
};
export default HeaderSelectMenuItem;
